import "./SelectProduct.css";
import { useNavigate } from "react-router-dom";
import { useEffect } from "react";
import { Typography } from "antd";

import { useSelectedProductStore } from "../store/select-product-store";
import { LlmWhispererSelect, UnstractSelect } from "../assets/llmWhisperer";
import { PRODUCT_NAMES } from "../helpers/common";
// import { APIHubSelect } from "../assets/verticals/index";

function SelectProduct() {
  const { setSelectedProduct, selectedProduct } = useSelectedProductStore();
  const navigate = useNavigate();

  useEffect(() => {
    if (
      selectedProduct &&
      Object.values(PRODUCT_NAMES).includes(selectedProduct)
    ) {
      navigate("/");
    }
  }, [selectedProduct]);

  return (
    <div className="select-prod-bg">
      <div className="select-container">
        <Typography className="select-prod-desc">
          Turn any document into consistently structured JSON data <br />
          <Typography.Link
            href="https://docs.unstract.com/unstract_platform/index"
            target="_blank"
          >
            Learn more
          </Typography.Link>
        </Typography>
        <UnstractSelect
          className="select-button"
          onClick={() => setSelectedProduct("unstract")}
        />
      </div>
      <div className="select-container">
        <Typography className="select-prod-desc">
          Prepare documents for consumption by LLMs <br />
          <Typography.Link
            href="https://docs.unstract.com/llm_whisperer/apis/index"
            target="_blank"
          >
            Learn more
          </Typography.Link>
        </Typography>
        <LlmWhispererSelect
          className="select-button"
          onClick={() => setSelectedProduct("llm-whisperer")}
        />
      </div>
      {/* <div className="select-container">
        <Typography className="select-prod-desc">
          Ready-to-go APIs for structured JSON extraction from popular
          documents. <br />
          <Typography.Link
            href="https://docs.unstract.com/llm_whisperer/apis/index"
            target="_blank"
          >
            Learn more
          </Typography.Link>
        </Typography>
        <APIHubSelect
          className="select-button"
          onClick={() => setSelectedProduct("verticals")}
        />
      </div> */}
    </div>
  );
}

export { SelectProduct };
